import { AxiosResponse } from "axios";
import { Requests } from "../../config/api";
import { getRequest } from "../commonActions/get";
import { GetOwnProfileProps } from "../../declarations/ownprofile";
import { error } from "console";

export const GetOwnProfile = async ({
  setLoading,
}: GetOwnProfileProps): Promise<any> => {
  try {
    setLoading && setLoading(true);
    const response: AxiosResponse = await getRequest({
      route: Requests.get.getownProfile,
    });
    setLoading && setLoading(false);

    console.log("Raw API response:", response);
    console.log("Response data:", response?.data);

    const { profile, success } = response?.data;

    const message = response?.data?.message;
    const errors = response?.data?.message;
    const status = response?.status;

    // Ensure we have a valid MongoDB ID
    if (profile && !profile._id) {
      console.error("Profile missing _id:", profile);
      throw new Error("Profile ID is missing or invalid");
    }

    return {
      profile,
      success,
      errors,
      message: message,
      status: status,
    };
  } catch (error) {
    setLoading && setLoading(false);
    console.error("Error in GetOwnProfile:", error);
    throw error;
  }
};
